import $ from 'jquery';
const initSubMenuEffect = () => {
    document.querySelectorAll('.subMenu_solutions_popin').forEach((link) => {



        let domBubble = document.createElement('div');
        domBubble.classList.add('link_circle_bubble');

        let domCircle = document.createElement('div');
        domCircle.appendChild(domBubble);
        domCircle.classList.add('link_circle');

        link.appendChild(domCircle);

        let circle = link.querySelector('.link_circle');
        let bubble = link.querySelector('.link_circle_bubble');

        if (!circle || !bubble) return;

        let buttonBounds = link.getBoundingClientRect();

        link.addEventListener('mouseenter', (e) => {
            buttonBounds = link.getBoundingClientRect();
            let posX = e.clientX - buttonBounds.left;
            let posY = e.clientY - buttonBounds.top;
            circle.style.transform = 'translate(' + posX + 'px,' + posY + 'px)';

            bubble.style.transform = 'scale(1)';
            bubble.style.opacity = '1';
        });

        link.addEventListener('mouseleave', () => {
            bubble.style.transform = 'scale(0)';
            bubble.style.opacity = '0';
        });
    })
};



export { initSubMenuEffect };
